module.exports = __webpack_public_path__ + "img/product_banner.b05e94a9.png";